import React from 'react';
import { withSearch } from '@elastic/react-search-ui';
import { createUseStyles } from 'react-jss';

import Header from '../components/Header';
import SearchBar from '../components/SearchBar';
import SearchResult from '../components/search/SearchResult';
import Layout from '../components/Layout';
import Sidebar from '../components/search/Sidebar';
import Ads from '../components/search/Ads';
import SearchFilter from '../components/search/SearchFilter';
import { md, media, sm } from '../utils/constants';
import { useWindowSize } from '../hooks/useWindowSize';
import SearchFilterMobile from '../components/search/SearchFilterMobile';

const useStyles = createUseStyles((theme) => ({
  root: {
    composes: 'flexRow justifyCenter',
    margin: -theme.spacing(3),
    [media.smDown]: {
      flexDirection: 'column',
      margin: 'auto',
    },
  },
  layout: {
    composes: 'flexColumn',
  },
  item: {
    margin: theme.spacing(3),
    [media.smDown]: {
      margin: 'auto',
    },
  }
}));

const Search = (props) => {
  const classes = useStyles();

  const { isLoading } = props;

  const { width } = useWindowSize();

  return (
    <div className={classes.root}>
      {width <= sm && (
        <Layout>
          <Header />
        </Layout>
      )}
      <Sidebar className={classes.item}>
        {width <= sm ? <SearchFilterMobile /> : <SearchFilter />}
      </Sidebar>
      <Layout rootClassName={classes.item} className={classes.layout}>
        {width > sm && <Header />}
        <SearchBar />
        <SearchResult isLoading={isLoading} />      
      </Layout>
      {width >= md && (
        <Sidebar className={classes.item}>
          <Ads />
        </Sidebar>
      )}
    </div>
  );
}

export default withSearch(({ isLoading }) => ({ isLoading }))(Search);


